Customer.Users ||= {}

class Customer.Users.ProfilePreviewAttributesView extends Backbone.View

  className: 'main-profile-section main-profile-social-users'

  initialize: (@options = {}) ->
    @profile = @options.profile
    @socialUsers = @options.social_users
    @attributeDefinitions = @options.attribute_definitions
    @getSocialUserType = @options.get_social_user_type
    @socialId = @options.ticket_social_user_id
    @socialUserViews =
      facebook: Customer.Users.FacebookProfileView
      twitter: Customer.Users.TwitterProfileView
      disqus: Customer.Users.DisqusProfileView
      email: Customer.Users.EmailProfileView
      instagram: Customer.Users.InstagramProfileView
      youtube: Customer.Users.YoutubeProfileView
      livefyre: Customer.Users.LivefyreProfileView
      webchat: Customer.Users.WebchatProfileView
      apple_app_store: Customer.Users.AppleAppStoreProfileView
      google_play: Customer.Users.GooglePlayProfileView
      whatsapp: Customer.Users.WhatsappProfileView
      linkedin: Customer.Users.LinkedInProfileView
      tiktok: Customer.Users.TikTokProfileView

  render: ->
    @renderSocialUsers()
    @showUnmerge()

    attributes = []
    _.each @attributeDefinitions, (definition) =>
      key = _.find(_.keys(@profile.values), (key) -> definition.code == key)
      attributes.push
        definition: definition,
        value: if key then @profile.values[key] else []

    @customAttributesView = new Customer.Users.ProfilePreviewCustomAttributesView
      profileID: @profile.id,
      attributeCollection: new Customer.UserProfileAttributeCollection(attributes)
    @listenTo @customAttributesView, 'profile_custom_attributes:change', (response) =>
      @trigger 'profile_custom_attributes:change', response
    @listenTo @customAttributesView, 'profile_custom_attributes:restore', =>
      @trigger 'profile_custom_attributes:restore'

    @$el.append JST['backbone/templates/customer/users/last_customer_response']
      last_customer_response: @profile.last_customer_response
    @$el.append @customAttributesView.render().el
    @

  afterRender: ->
    @customAttributesView.afterRender()

  isBeingModified: ->
    @customAttributesView.isBeingModified()

  renderSocialUsers: ->
    for socialUser in @socialUsers
      socialUserView = new @socialUserViews[@getSocialUserType(socialUser)](socialUser)
      @listenTo socialUserView, 'updateName', (name) => @trigger('updateName', name)
      @listenTo socialUserView, 'profile:remove-social-user', (social_user) => @removeSocialUser(social_user)
      @$el.append socialUserView.render().el

  validateFieldsAreFilledAndExists: (fields) ->
    message = null
    success = true
    _.each(fields, (field) =>
      found = false
      _.each(@attributeDefinitions, (definition) ->
        found = true if field == definition.code
      )
      unless found
        success = false
        message = "custom profile attribute with code: #{field} is missing, please complete it in order to continue"
    )
    if success
      _.each(@customAttributesView.attributeViews, (attributeView) ->
        model = attributeView.model
        code = model.get('definition').code
        if fields.indexOf(code) > -1
          if _.isEmpty(model.get('value'))
            attributeView.markAsError()
            success = false
      )
      message = I18n.t('user_profiles.custom_attributes.fill_mandatory_fields') unless success
    {
      success
      message
    }

  editModeOn: ->
    undefined

  editModeOff: ->
    undefined

  showUnmerge: ->
    @$el.find('.remove-profile').toggle(@socialUsers.length > 1)

  removeSocialUser: (socialUser) ->
    swal
      title: I18n.t('user_profiles.edit_mode.confirmation_modal.title')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('user_profiles.edit_mode.confirmation_modal.confirm')
      cancelButtonText: I18n.t('user_profiles.edit_mode.confirmation_modal.cancel')
      closeOnConfirm: true
      => @_beginUnmerge socialUser

  _beginUnmerge: (socialUser) ->
    @$el.find('.remove-profile').hide()
    @$el.html('').addClass 'processing'
    $.ajax
      type: 'POST'
      url: '/profiles/api/separate_user_profile'
      data:
        profile: @profile.id
        source: socialUser.source
        id: socialUser.social_network_id
        ticket_social_user_id: @socialId
      success: @_unmergeComplete

  _unmergeComplete: (ajaxResponse) =>
    if ajaxResponse.success then @_unmergeSuccess(ajaxResponse.profile) else @_unmergeError()
    @$el.removeClass 'processing'

  _unmergeSuccess: (profile) ->
    @trigger('profile:social-user-removed', profile)
    @renderSocialUsers()

  _unmergeError: ->
    @showUnmerge()

  onAttributesValidationError: (userProfileAttributeErrors) =>
    @customAttributesView.onAttributesValidationError(userProfileAttributeErrors)

  onTicketClose: =>
    @customAttributesView.onTicketClose()
